import React from 'react';
import { useParams } from 'react-router-dom';
import StaticLayout from '@components/layout/StaticLayout';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import { MAIN_THEME } from '@styles';
import { entityView } from './content';
import EntityInfoWidget from '@components/widgets/entity-info/EntityInfoWidget';
import BrandsTable from './widgets/BrandsTable';
import ModelsTable from './widgets/ModelsTable';

const LookupDetailsPage: React.FC = () => {
  const params = useParams();
  const entityId = params.id; // Will be 'Insurance-Brands', 'Insurance-Models', or undefined

  return (
    <StaticLayout
      name="Lookups"
      leftChildren={
        <EntityInfoWidget
          background={MAIN_THEME.color.white}
          classification={{ classifications: {}, value: '' }}
          progress={100}
          supportsClassification={true}
          supportsProgressBar={true}
          title={entityId === 'Insurance-Brands' ? 'Brand' : 'Models'}
          view={entityView}
        />
      }
      mainChildren={
        <WidgetSection>
          {(!entityId || entityId === 'Insurance-Brands') && (
            <div>
              <BrandsTable />
            </div>
          )}
          {(!entityId || entityId === 'Insurance-Models') && (
            <div>
              <ModelsTable />
            </div>
          )}
        </WidgetSection>
      }
    />
  );
};

export default LookupDetailsPage;
